// export function convertRSSToJson(feedUrl, count = 10, offset = 0) {
//   const apiKey = 'ep07s7cbkjytisrmg0nodl02pon1v3gl08phfs00';
//   const escapedUrl = encodeURIComponent(feedUrl);

//   return `https://api.rss2json.com/v1/api.json?rss_url=${escapedUrl}&api_key=${apiKey}&count=${count}&offset=${offset}`;
// }

import { cdnApi, firestoreApi, getFirebaseUser } from './utils';
import FireStoreParser from 'firestore-parser';

// export const cdnApi = cdnApi; // 'https://podcastapp-767c2.firebaseapp.com/';

export async function convertRSSToJsonLatestFirestore(collectionId) {
  const response = await fetch(firestoreApi + 'latestEpisodes/' + collectionId);
  const result = await response.json();
  let parsedResult = FireStoreParser(result);
  console.dir(parsedResult);
  if ('fields' in parsedResult) {
    const rssFeedInJson = parsedResult['fields']['rssFeedInJson'];
    return rssFeedInJson;
  }
  return {};
}

export function convertRSSToJsonLatest(feedUrl, collectionId, count, genresArray, lastEpisodeGuid) {
  const escapedUrl = encodeURIComponent(feedUrl);
  let genres = genresArray && encodeURIComponent(genresArray.join(','));
  let apiString = `${cdnApi}getRSSFeedV2?rss_url=${escapedUrl}&collectionId=${collectionId}&genres=${genres}&episodeFrom=latest`;
  if (typeof count !== 'undefined' && count > 0) {
    apiString += `&count=${count}&mainFeed=false`;
  }
  console.dir(getFirebaseUser());
  if (parseInt(collectionId) < -1 && getFirebaseUser() && getFirebaseUser().uid) {
    apiString += `&userUID=${getFirebaseUser().uid}`
  }
  if (lastEpisodeGuid) {
    apiString += `&guid=${encodeURIComponent(lastEpisodeGuid)}`
  }
  console.dir(apiString);
  // return encodeURIComponent(apiString);
  return apiString;
}

export function convertRSSToJsonMore(feedUrl, collectionId, episodeFrom, count, genresArray) {
  const escapedUrl = encodeURIComponent(feedUrl);
  let genres = genresArray && encodeURIComponent(genresArray.join(','));
  let countString = '';
  if (typeof count !== 'undefined' && count > 0) {
    countString += `&count=${count}`;
  }
  let apiString = `${cdnApi}getRSSFeedV2?rss_url=${escapedUrl}&collectionId=${collectionId}&genres=${genres}&episodeFrom=${episodeFrom}${countString}&mainFeed=false`;
  if (parseInt(collectionId) < -1 && getFirebaseUser() && getFirebaseUser().uid) {
    apiString += `&userUID=${getFirebaseUser().uid}`
  }
  // console.log('apiString : ' + apiString);
  // return encodeURIComponent(apiString);
  return apiString;
}